import { useSelector, useDispatch } from 'react-redux';
import { usePostLoginMutation } from '../services/endpoints/authenticationEndpoints';
import { getCookie } from '../utils/utilFunctions';
import {
	getLocalAuth,
	ARM_TOKEN_COOKIE_GN,
	ARM_TOKEN_COOKIE_PORTAL,
	ACCOUNT_SOURCE,
	removeLocalStorageAuth
} from '../utils/environmentUtils';
import { setAccountSource } from '../pages/Login/slice';

const useAuthentication = () => {
	//ARM-241: Using gpm-auth-gn and gpm-auth-portal depending on the account source the token is from. This is so we can have seperate permissions when a user is using arm from gn and in portal
	const accountSource = useSelector((state) => state?.login?.accountSource);
	//If we are in an iFrame that means we need to use portal token
	const isiFrame = new URLSearchParams(window.location.search).get('iFrame');
	const apiToken = getLocalAuth(accountSource)?.access_token;
	const [callLogin] = usePostLoginMutation();
	const dispatch = useDispatch();

	const hasAccess = async () => {
		try {
			// Need seperate cookies for gn and portal so a user can logout of arm from gn without deleting the portal cookie.
			const tokenGN = getCookie(ARM_TOKEN_COOKIE_GN);
			const tokenPortal = getCookie(ARM_TOKEN_COOKIE_PORTAL);

			// If we do not have a gn or portal cookie and we do not have a localstorage (apiToken) then we need to remove all localstorage and return false.
			if (!Boolean(tokenGN) && !Boolean(tokenPortal) && !apiToken) {
				removeLocalStorageAuth(true);
				return false;
			}

			// If we do not have localstorage (apiToken) or we have either a GN or portal cookie that is not empty and that cookie is not equal to our local storage token (old cookie) Then we callLogin and update our localStorage tokens.
			if (
				!apiToken ||
				(tokenGN && tokenGN !== localStorage.getItem('gpm-auth-jwt')) ||
				(tokenPortal && tokenPortal !== localStorage.getItem('gpm-auth-jwt'))
			) {
				// Use portal token if we are in an iframe and the portal cookie exists
				const token = isiFrame && tokenPortal ? tokenPortal : tokenGN;
				const response = await callLogin({ jwt: token });
				if (response?.data) {
					localStorage.setItem('gpm-auth-jwt', token);
					// Check if we are coming from gn or portal
					if (response.data?.accountSource === ACCOUNT_SOURCE.GRANTS_NETWORK) {
						dispatch(setAccountSource({ accountSource: ACCOUNT_SOURCE.GRANTS_NETWORK }));
						localStorage.setItem('gpm-auth-gn', JSON.stringify(response.data));
						// Assume portal if not gn, or if no account source
					} else {
						dispatch(setAccountSource({ accountSource: ACCOUNT_SOURCE.PORTAL }));
						localStorage.setItem('gpm-auth-portal', JSON.stringify(response.data));
					}
					if (response.data?.access_token) {
						return true;
					}
					removeLocalStorageAuth(false, accountSource);
					return false;
				}
			} else {
				return true;
			}
		} catch (error) {
			removeLocalStorageAuth(false, accountSource);
			console.error(error);
			return false;
		}
	};

	return {
		hasAccess: () => hasAccess()
	};
};

export default useAuthentication;
